<template>
  <div class="main-container">
    <div class="search-box">
      <!-- <div class="input-item">
        <span class="label">费用日期</span>
        <DatePicker type="date" format="yyyy-MM-dd" placeholder="选择日期" v-model="searchParams.commissionDate"></DatePicker>
      </div> -->

      <div class="input-item">
        <span class="label">结算报表名称</span>
        <Input v-model="searchParams.reportName" clearable placeholder="请输入" />
      </div>

      <div class="input-item">
        <span class="label">结算机构</span>
        <selectTree v-model="searchParams.orgIds" type="4" :maxTagCount="1" :multiple="true" ref="selectTreeRef"> </selectTree>
      </div>

      <div class="input-item">
        <span class="label">结算状态</span>
        <Select v-model="searchParams.settlementStatus" transfer placeholder="请选择" clearable>
          <Option value="1">已结算</Option>
          <Option value="0">待结算</Option>
        </Select>
      </div>

      <div class="input-item">
        <span class="label">结算日期</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.settlementDate"
          @on-change="searchParams.settlementDate = $event"
        ></DatePicker>
      </div>

      <div class="btn-item">
        <Button type="primary" @click="searchAjax">查询</Button>
        <Button type="primary" class="btn-reset" ghost @click="resetSearch">重置</Button>
      </div>
    </div>
    <Button type="primary" class="btn" @click="addNewReport">新建结算报表</Button>

    <div class="tableBox">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="settlementStatus">
          <div class="settlement-status">
            <span v-if="row.settlementStatus == 0" class="tag-settled">待结算</span>
            <span v-else class="tag-be">已结算</span>
          </div>
        </template>

        <template slot-scope="{ row }" slot="reportName">
          <span class='table-btn' @click="toDetailPage(row)">{{ row.reportName }}</span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="delRow(row)">删除</span>
        </template>
      </Table>
      <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />
    </div>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import selectTree from '@/components/system/selectTree3';
import filter from '@/api/filter';
export default {
  mixins: [pageTool, common],
  components: {
    selectTree
  },
  data() {
    return {
      searchParams: {},
      total: null,
      columns: [
        {
          title: '结算日期',
          align: 'center',
          key: 'settlementDate',
          minWidth: 120,
          render(h, params) {
            let settlementDate = params.row.settlementDate;
            return <span>{filter.filterTime(settlementDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '报表名称',
          align: 'center',
          key: 'reportName',
          minWidth: 210,
          slot: 'reportName'
        },
        {
          title: '结算机构',
          align: 'center',
          key: 'orgName',
          minWidth: 200,
          tooltip: true,
          tooltipMaxWidth: 700
        },
        {
          title: '结算状态',
          align: 'center',
          minWidth: 120,
          slot: 'settlementStatus'
        },
        {
          title: '总人数',
          align: 'center',
          key: 'userNum',
          minWidth: 100
        },
        {
          title: '保单数',
          align: 'center',
          key: 'policyNum',
          minWidth: 100
        },
        {
          title: '总保费',
          align: 'center',
          key: 'fee',
          minWidth: 130
        },
        {
          title: '基本法基础费用（元）',
          align: 'center',
          key: 'methodIncome',
          minWidth: 180
        },
        {
          title: '基本法外基础费用',
          align: 'center',
          key: 'baseIncome',
          minWidth: 170,
          renderHeader: (h, params) => {
            return (
              <div>
                <span>基本法外基础费用</span>
                <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip" transfer={true}>
                  <Icon style="color:#A8ADB7;margin-left:4px;" type="md-help-circle" />
                  <div slot="content">
                    <p>活动费用、后置费用等</p>
                  </div>
                </Poptip>
              </div>
            );
          }
        },
        {
          title: '无门槛限时加费',
          align: 'center',
          key: 'platformActivityIncome',
          minWidth: 140
        },
        {
          title: '基本法外团队长合计',
          align: 'center',
          key: 'baseLeaderIncome',
          minWidth: 140,
          renderHeader: (h, params) => {
            return (
              <div>
                <span>基本法外团队长合计</span>
                <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip" transfer={true}>
                  <Icon style="color:#A8ADB7;margin-left:4px;" type="md-help-circle" />
                  <div slot="content">
                    <p>团队长首期续期基础费用管理费</p>
                  </div>
                </Poptip>
              </div>
            );
          }
        },
        {
          title: '费用合计',
          align: 'center',
          key: 'totalIncome',
          minWidth: 120
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 100,
          fixed: 'right'
        }
      ],
      tableData: []
    };
  },

  activated() {
    this.getList();
  },

  created()  {
    this.searchAjax();
  },

  methods: {
    resetSearch() {
      this.searchParams = {};
      this.searchAjax();
    },

    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },

    getList() {
      this.listLoading = true;
      let data = JSON.parse(JSON.stringify(this.searchParams));
      data.commissionDate = data.commissionDate && filter.filterTime(data.commissionDate, 'YYYY-MM-DD');
      // 结算日期
      if (data.settlementDate && data.settlementDate[0]) {
        data.settlementDateStart = data.settlementDate[0];
        data.settlementDateEnd = data.settlementDate[1];
      }
      delete data.settlementDate;
      this.$http({
        url: '/buz/userSettlementReport/read/page',
        type: 'POST',
        data: {
          ...data,
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          type: 1
        }
      })
        .then(res => {
          this.total = res.total;
          this.tableData = res.data;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },

    // 详情
    toDetailPage(row) {
      let step = row.step;
      if (step == 1) {
        this.openPageTabTags('/financialManage/basicLawSettlement/editReport', { reportId: row.id, isAdd: 0, step: '1', reportName: row.reportName });
      } else {
        this.openPageTabTags('/financialManage/basicLawSettlement/editReport', {
          reportId: row.id,
          reportName: row.reportName,
          step,
          settlementDate: filter.filterTime(row.settlementDate, 'YYYY-MM-DD'), //结算日期
          commissionDate: filter.filterTime(row.commissionDate, 'YYYY-MM-DD') //费用日期
        });
      }
    },

    // 删除
    delRow(row) {
      if(!this.$units.pointAction('offline_81_1_2')) {
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      this.$notice.inquiry(`确认删除操作？`).then(() => {
        this.$http({
          url: '/buz/userSettlementReport/del',
          type: 'GET',
          data: {
            id: row.id
          }
        }).then(res => {
          this.$notice.success('删除成功');
          this.searchAjax();
        });
      });
    },

    // 新建结算报表
    addNewReport() {
      if(!this.$units.pointAction('offline_81_1_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      this.openPageTabTags('/financialManage/basicLawSettlement/newReport', { isAdd: 1, step: '1', reportName: '新建结算报表', time: Date.now() });
    }
  }
};
</script>

<style lang="scss" scoped>
.tableBox {
  margin-top: 15px;
  .settlement-status {
    display: flex;
    .tag-settled {
      width: 55px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      border-radius: 2px;
      font-size: 13px;
      color: #e3461f;
      border: 1px solid #ffc1b2;
      background: #fff5f2;
    }
    .tag-be {
      width: 55px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      border-radius: 4px;
      font-size: 13px;
      color: #35bf3f;
      border: 1px solid #abeaae;
      background: #f6fcf4;
    }
  }
}
</style>
